<div [class]="headQuestion">
  <div class="p-text">
    <div
      role="article"
      class="table-display-div"
      [innerHtml]="displayQuestion(questionPreview) | sanitizeHtml"
    ></div>
  </div>
</div>
<button
  #showAnswersButton
  *ngIf="refType == 'scalar' && !questionHideArray.get(indexItem)"
  class="bottom-18 top-3 show-answers-button pl-0"
  [id]="'show-answers-button-' + sourceIndexId"
  [attr.aria-expanded]="false"
  [attr.aria-controls]="'answers-panel-' + sourceIndexId"
  (click)="toggleQuestionHideArray('hide')"
>
  <i class="dpg-icon dpg-icon-accordion-close">
  </i>
  <span class="answer-span">Show Answers</span>
  <span class="sr-only"> for {{ questionTitle }}</span>
</button>
<div 
  *ngIf="refType == 'scalar' && questionHideArray.get(indexItem)"
>
  <button
    #hideAnswersButton
    [id]="'hide-answers-button-' + sourceIndexId"
    [attr.aria-expanded]="true"
    [attr.aria-controls]="'answers-panel-' + sourceIndexId"
    (click)="toggleQuestionHideArray('show')"
    class="hide-answers-button pl-0">
    <i class="dpg-icon dpg-icon-accordion-open"></i>
    <span class="answer-span">Hide Answers</span>
    <span class="sr-only"> for {{ questionTitle }}</span>
  </button>
  <div [class]="headQuestion" [id]="'answers-panel-' + sourceIndexId">
    <div
      tabindex="-1"
      class="display-answer-div"
      role="group"
      [attr.aria-labelledby]="'answers-label-' + sourceIndexId"
      [innerHtml]="displayAnswers(questionPreview) | sanitizeHtml"
    ></div>
  </div>
</div>
